import React from "react";

import { Text, View, StyleSheet, Canvas } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  list: {
    marginTop: 10,
    width: "100%"
  },
  item: {
    flexDirection: "row",
    alignItems: "flex-start",
    display: "flex",
    marginBottom: 4,
    width: "100%"
  },
  bullet: {
    width: 6,
    height: 6,
    marginRight: 10,
    marginTop: 4
  },
  text: {
    flex: 1
  }
});

export const BulletList = ({ children }) => (
  <View style={styles.list}>{children}</View>
);

BulletList.Item = ({ children }) => (
  <View style={styles.item} wrap={false}>
    <Canvas style={styles.bullet} paint={paintFn} />

    <View style={styles.text}>
      <Text>{children}</Text>
    </View>
  </View>
);

function paintFn(painter, w, h) {
  return painter.roundedRect(1, 1, w - 2, h - 2, w / 2).fill("#000");
}
